/** Prefer slug in public listing paths; cuid still works as fallback. */
export function listingPathSegment(listing: {
  id: string;
  slug?: string | null;
}): string {
  return listing.slug || listing.id;
}

/** Canonical public URL: /listings/<slug> (campaign id not in path). */
export function buildAuctionListingPath(
  _campaignId: string | null | undefined,
  listing: { id: string; slug?: string | null },
): string {
  return `/listings/${listingPathSegment(listing)}`;
}

/** @deprecated alias — same as buildAuctionListingPath */
export function buildListingPath(
  campaignId: string | null | undefined,
  listing: { id: string; slug?: string | null },
): string {
  return buildAuctionListingPath(campaignId, listing);
}
